import ArvorePermissoesGeral from './ArvorePermissoesGeral'
import enhance from './ArvorePermissoesGeral.enhancer'

export default enhance(ArvorePermissoesGeral)



// WEBPACK FOOTER //
// ./src/modules/permissoes/components/ArvorePermissoesGeral/index.js